import { makeStyles } from "@material-ui/core";
import React from "react";
import Card from './cardItems';

let useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        flexDirection: 'column',
        ...theme.grid.gridMdContent,
        width: "100%",
        // margin: "45px auto",
        maxWidth: '100%',
        backgroundImage: `url('/assets/images/newImages/bgEnergy.jpg')`,
        // backgroundImage: `linear-gradient(to bottom, rgba(11, 23, 66, 0.7), rgba(11,23,66, 07)), url('/assets/images/newImages/bgEnergy.jpg');`,
        // backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.7), rgba(0,0,0, 0.7)), url('/assets/images/newImages/bgKala.png');`,
    },
    gridConent: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        ...theme.grid.gridMdContent,
        width: "65%",
        width: 550,

        minHeight: 190,
        margin: "0px auto",
        maxWidth: '95%',
        marginBottom: 50,
        '@media (max-width:1001px)': {
            width: '400px',
            marginTop: 50
        },
        '@media (max-width:500px)': {
            width: '100%',
        },
        '@media (max-width:460px)': {
            flexDirection: 'column'
        },
    },
    line: {
        borderRadius: 3,
        height: 4,
        border: 'none',
        backgroundColor: theme.palette.light.type2,
        position: 'absolute',
        top: -10,
        width: 30,
        right: '50%',

    },
    gridTitle: {
        position: 'relative',
        marginTop: 100,
        textAlign: 'center',

        '@media (max-width:445px)': {
            textAlign: 'center',
        },
    },
    title: {
        fontSize: 28,
        color: 'white'
    },
    gridDesc: {
        width: '50%',
        minWidth: 500,
        marginTop: 15,
        fontSize: 16,
        margin: 'auto',
        color: '#FFFFFF',
        '@media (max-width:650px)': {
            minWidth: '85%',
        },
    }
}))

export default function Index() {

    let classes = useStyles();

    return (
        <div className={classes['root']}>
            <div className={classes['gridTitle']}>
                <div className={classes['line']} />
                <h3 className={classes['title']}>
                    انواع بازارهای بورس انرژی ایران
                </h3>
                <div className={classes['gridDesc']}>
                    <p>

                        بورس انرژی ایران دارای سه بازار فیزیکی، مشتقه و فرعی است. در بازار فیزیکی، کالاهای پذیرفته شده در بورس و در بازار مشتقه، اوراق بهادار مبتنی بر کالاهای پذیرفته شده در بورس معامله می‌شوند. بازار فرعی نیز شامل کالاهای تک  و خارج از گونه است.

                    </p>
                    <p>
                        خود بازار فیزیکی شامل سه تابلوی برق، نفت و گاز و تابلوی سایر حامل‌های انرژی و بازار مشتقه شامل سه تابلوی قرارداد سلف موازی استاندارد، قرارداد آتی و قرارداد اختیار معامله  که هر کدام از این تابلوها نیز دو رینگ داخلی و بین‌المللی دارند.
                    </p>
                </div>
            </div>
            <div className={classes['gridConent']}>
                {
                    dataService?.map((item, index) => {
                        return (
                            <Card data={item} key={index} />
                        )
                    })
                }
            </div>
        </div>
    );
}


let dataService = [
    {
        title: "بازار فیزیکی",
        desc: "",
        icon: "/assets/icons/enrgy/sabad.svg",
    },
    {
        title: "بازار مشتقه",
        desc: "",
        icon: "/assets/icons/enrgy/bazar.svg",
    },

    {
        title: "بازار فرعی",
        desc: "",
        icon: "/assets/icons/enrgy/bazarMony.svg",
    },



    // {
    //     title: "پذیرش و ",
    //     desc: "عرضه کالا",
    //     icon: "/assets/icons/kala/serviceKala2.svg",
    // },

    // {
    //     title: "مشاوره‌های تخصصی ",
    //     desc: "در بورس کالا",
    //     icon: "/assets/icons/kala/serviceKala1.svg",
    // },



]